import React, { createContext, useContext } from 'react';
import { useLocalStorage } from '../hooks/use-local-storage';

type MessagesState = 'minimized' | 'maximized' | 'closed';

type PersistentMessagesContext = {
  messagesState: MessagesState;
  setMessagesState: (state: MessagesState) => void;
};

const PersistentMessagesContext = createContext<PersistentMessagesContext | null>(null);

export const PersistentMessagesProvider = ({ children }: { children: React.ReactNode }) => {
  const [messagesState, setMessagesState] = useLocalStorage<MessagesState>('pillexa:messagesState', 'closed');
  
  return (
    <PersistentMessagesContext.Provider
      value={{
        messagesState,
        setMessagesState,
      }}
    >
      {children}
    </PersistentMessagesContext.Provider>
  );
};

export const usePersistentMessages = () => {
  const context = useContext(PersistentMessagesContext);
  if (!context) {
    throw new Error('usePersistentMessages must be used within PersistentMessagesProvider');
  }
  return context;
};